export const JSON_MIME = "application/json";
export const CONTENT_TYPE_HEADER = "Content-Type";
export const FETCH_ERROR = Symbol();
//# sourceMappingURL=constants.js.map